export default "__VITE_ASSET__fpfAZEc5__"